// removed by extract-text-webpack-plugin
module.exports = {"miniMiranda":"_1XmsgXwTEY"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/presentational/AppFooter/AppFooter.module.less
// module id = 997
// module chunks = 3